/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { map, uniq } from 'lodash';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { PreInvoiceSummary, PreInvoiceDetail } from './tableHead';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getPreInvoiceDetail, getPreInvoiceSummary } from '../Store/action';
import {normalizeDate } from '../../../../SharedModules/utilities/utilities';

const DisplayPreInvoice = () => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      quarterFrom: getQuarter,
      begin: beginDateValue,
      end: endDateValue,
      selectedReportOption: getSelectedReportOptionList,
      preInvoiceSum: getPreInvoiceSum,
      preInvoiceDet: getPreInvoiceDetailList,
      selectedOption: getSelectedOptionList,
    },
  } = useSelector((state) => state?.sharedState?.PreInvoiceReducer);

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [preInvoiceSummary, setPreInvoiceSummary] = useState([]);
  const [preInvoiceDetail, setPreInvoiceDetail] = useState();
  const [labelerOrder, setLabelerOrder] = useState('asc');
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filteredRows1, setFilteredRow1] = React.useState([]);
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const endDate = normalizeDate(endDateValue,'to')
  const startDate= normalizeDate(beginDateValue,'from')
  const finalEndDate = endDate || startDate;
  // preInvoice Summary api

  // useEffect(() => {
  //   dispatch(
  //     getPreInvoiceSummary({
  //       rebateProgramCd: getRebateProgramName?.rebateProgramCd,
  //       beginDate: beginDateValue || 0,
  //       endDate: endDateValue || 0,
  //       // endDate: finalEndDate,
  //       allDate: getSelectedOptionList == 'Adjustment_Date_Range' ? 0 : 1,
  //       qtr: getQuarter || 'null',
  //       allqtr: getSelectedOptionList == 'Invoice_Quarter' ? 0 : 1,
  //     })
  //   );
  // }, []);
  const dataSumm = getPreInvoiceSum?.preInvoiceUnitAdjustmentsVO ?? [];
  // preInvoice Detail api

  // useEffect(() => {
  //   dispatch(
  //     getPreInvoiceDetail({
  //       rebateProgramCd: getRebateProgramName?.rebateProgramCd,
  //       beginDate: beginDateValue || 0,
  //       // endDate: finalEndDate,
  //       endDate: endDateValue || 0,
  //       allDate: getSelectedOptionList == 'Adjustment_Date_Range' ? 0 : 1,
  //       qtr: getQuarter || 'null',
  //       allqtr: getSelectedOptionList == 'Invoice_Quarter' ? 0 : 1,
  //     })
  //   );
  // }, []);

  const dataDet =
    getPreInvoiceDetailList?.preInvoiceUnitAdjustmentDetailsVO ?? [];
  // sort the data array in ascending order by
  dataDet.sort((a, b) => a.labelerCode - b.labelerCode);

  // create a new array with all the keys
  const newData = [];
  dataDet.forEach((item) => {
    const newItem = {};
    Object.keys(item).forEach((key) => {
      newItem[key] = item[key];
    });
    newData.push(newItem);
  });
  useEffect(() => {
    setPreInvoiceSummary(dataSumm);
  }, [getPreInvoiceSum]);
  const sortedKey = (arr, orderBy) => {
    const multiplier = orderBy === 'desc' ? -1 : 1;
    arr.sort(
      (a, b) =>
        multiplier *
        (a.toLowerCase() > b.toLowerCase()
          ? 1
          : a.toLowerCase() < b.toLowerCase()
          ? -1
          : 0)
    );
    return arr;
  };
  const groupByData = (data, key, orderBy) => {
    const tempObj = {};
    const uniqueKeys = [...new Set(data?.map((prop) => prop.labelerCode))];
    if (uniqueKeys?.length > 0) {
      uniqueKeys.forEach((item) => {
        const groupByList = JSON.parse(
          JSON.stringify(
            data?.filter((x) => {
              return x.labelerCode === item;
            })
          )
        );
        tempObj[item] = groupByList;
      });
    }
    const groupsKey = Object.keys(tempObj);
    const sortedObj = groupsKey
      .sort((a, b) => {
        if (orderBy === 'asc') {
          return parseFloat(a) - parseFloat(b);
        }
        return parseFloat(b) - parseFloat(a);
      })
      .reduce((obj, keys) => {
        obj[`${keys.toString()}S`] = tempObj[keys];
        return obj;
      }, {});
    return sortedObj;
  };

  const getFlatArrWithTotal = (groupedData, keyTextForTotal, totalText) => {
    let flatGroupDataWithTotal = [];
    if (Object.keys(groupedData)?.length > 0) {
      Object.keys(groupedData).forEach((item) => {
        let totalSumAdjustedURA = 0;
        totalSumAdjustedURA = groupedData[item]?.reduce(
          (accumulator, object) => {
            return (
              parseFloat(accumulator) + parseFloat(object.adjustedURA || 0)
            );
          },
          0
        );
        let totalSumCount = 0;
        totalSumCount = groupedData[item]?.reduce((accumulator, object) => {
          return (
            parseFloat(accumulator) +
            parseFloat(object.adjustmentRecordCount || 0)
          );
        }, 0);
        const obj = [
          {
            adjustedURA: totalSumAdjustedURA,
            adjustmentRecordCount: totalSumCount,
            ndc: ' ',
            adjustedUnit: '',
            [keyTextForTotal]: `${totalText} for ${item.substring(
              0,
              item.length - 1
            )}`,
          },
        ];

        flatGroupDataWithTotal = [
          ...flatGroupDataWithTotal,
          ...groupedData[item],
          ...obj,
        ];
      });
    }
    return flatGroupDataWithTotal;
  };

  useEffect(() => {
    const groupedData = groupByData(dataDet, 'labelerCode', labelerOrder);
    const flatData = getFlatArrWithTotal(groupedData, 'targetQtr', 'Total');
    setPreInvoiceDetail(JSON.parse(JSON.stringify(flatData)));
  }, [getPreInvoiceDetailList, labelerOrder]);

  const onSortChanged = (params) => {
    const colState = params.columnApi.getColumnState();
    const changedCol = colState.find((col) => col.sort !== null);

    if (
      changedCol?.colId === 'labelerCode' &&
      changedCol.sort !== labelerOrder
    ) {
      setLabelerOrder(changedCol.sort);
    }
  };

  // pdf header
  let secondInfo = '';
  let thirdInfo = '';
  secondInfo = `${
    getSelectedOptionList == 'Adjustment_Date_Range' ? 'Date Range' : 'Quarter'
  }: ${
    getSelectedOptionList == 'Adjustment_Date_Range'
      ? `${startDate} ` + '-' + ` ${finalEndDate}`
      : getQuarter
  }`;
  thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;

  // pinned row Summary

  // To update totals when no condition matches from filter
  const [filterApplySummary, setFilterApplySummary] = React.useState(false);
  const getFilterApplySummary = (filterApplied) => {
    setFilterApplySummary(filterApplied);
  };

  const sum = (property) => {
    const displayedRows = filterApplySummary ? filteredRows : preInvoiceSummary;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const total = (displayedRows || []).reduce((acc,obj)=>{
     const val = Number(obj?.[property]??0)
     return acc + (Number.isFinite(val)?val:0)
    },0)
    if (property === 'adjustmentRecordCount'){
      return Math.round(total).toString()
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        parseFloat(accumulator) +
        (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);

    return data ? parseFloat(data)?.toFixed(2) : '0';
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        labelerCode: 'Total',
        adjustedUnit: '',
        adjustedTotalAmt: sum('adjustedTotalAmt'),
        adjustmentRecordCount: sum('adjustmentRecordCount'),
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [preInvoiceSummary, filteredRows, filterApplySummary]);

  const onFilterChanged = (PreInvoiceSummary, type) => {
    const updatedRowData = PreInvoiceSummary.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };

  // pinned row detail

  // To update totals when no condition matches from filter
  const [filterApplyDetail, setFilterApplyDetail] = React.useState(false);
  const getFilterApplyDetail = (filterApplied) => {
    setFilterApplyDetail(filterApplied);
  };

  const sumD = (property) => {
    const displayedRowsD = filterApplyDetail ? filteredRows1 : preInvoiceDetail;
    const rowsToSum = (displayedRowsD || []).filter((object) => {
      const tq = object.targetQtr;
      const tqStr = tq === null ? '' : String(tq);
      return tqStr.indexOf('Total') === -1 && !object?.isBottomRow;
    });
    const total = (rowsToSum || []).reduce((acc, obj) => {
      const val = Number(obj?.[property] ?? 0);
      return acc + (Number.isFinite(val) ? val : 0);
    }, 0);
   
    if (property === 'adjustmentRecordCount') {
      return Math.trunc(total).toString();
    }
    const sumVal = rowsToSum.reduce((acc,obj)=>{
      const val = Number(obj?.[property]??0)
      return acc + (Number.isFinite(val))?val:0
    },0)
    const data = rowsToSum?.reduce((accumulator, object) => {     return (
        parseFloat(accumulator) +
        (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data)?.toFixed(2) : '0'; 
  };

  const createDataD = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        labelerCode: 'Total',
        adjustedUnit: '',
        adjustedURA: sumD('adjustedURA'),
        adjustmentRecordCount: sumD('adjustmentRecordCount'),
      });
    }

    return result;
  };
  const pinnedBottomRowDataD = useMemo(() => {
    return createDataD(1, 'Bottom');
  }, [preInvoiceDetail, filteredRows1, filterApplyDetail]);

  const onFilterChangedD = (preInvoiceDetail, type) => {
    const updatedRowData = preInvoiceDetail.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow1(updatedRowData);
  };
const rowsWithData = (rows)=>{
const arr = rows || []
return arr.filter((r)=>{
  const rowC = r?.targetQtr === null ? ''  : String(r.targetQtr).trim()
  return !rowC.startsWith('Total')
})


}
const detailSourceRows = filterApplyDetail ? filteredRows1 :preInvoiceDetail || []
const detailResultsCountData = (rowsWithData(detailSourceRows)|| [])
const summarySourceRows = filterApplySummary ? filteredRows1 : preInvoiceSummary || []
const summaryResultCountData = (rowsWithData(summarySourceRows) || [])
const summaryResultCount = [...summaryResultCountData].length || 0
const detailResultsCount = [...detailResultsCountData].length || 0
  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display PreInvoice Unit Adjustment"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  {getSelectedOptionList == 'Invoice_Quarter' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="Quarter "
                          id="Quarter1"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Quarter1' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={getQuarter}
                        />
                      </div>
                    </div>
                  )}
                  {getSelectedOptionList == 'Adjustment_Date_Range' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="Begin Date "
                          id="Begin_Date"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Begin_Date' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={startDate}
                        />
                      </div>
                    </div>
                  )}
                  {getSelectedOptionList == 'Adjustment_Date_Range' && (
                    <div className="mui-custom-form input-md">
                      <div className="col-12">
                        <TextField
                          label="End Date "
                          id="End_Date"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'End_Date' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={finalEndDate}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        {getSelectedReportOptionList == 'Detail' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              data-testid="Pre-Invoice-adjustment"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={preInvoiceDetail?.map((item)=>({
              ...item,
              adjustmentRecordCount:Number.isFinite(
                Number(item?.adjustmentRecordCount))? 
                Math.trunc(Number(item.adjustmentRecordCount)) : 0,
               }))}
              columnDefs={PreInvoiceDetail}
              exportFile
              animateRows
              sideBar={false}
              onSortChanged={onSortChanged}
              fileName="PreInvoiceUnitAdj"
              reportName="Pre-Invoice Unit Adjustment Report"
              isScrollOn
              defaultColWidth={180}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onFilterData={onFilterChangedD}
              onCellFocused={onCellFocused}
              pinnedBottomRowData={pinnedBottomRowDataD}
              info={{ secondInfo, thirdInfo ,rowCount :detailResultsCount}}

              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              getFilterApply={getFilterApplyDetail}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 20)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
        {getSelectedReportOptionList == 'Summary' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
            <TableGridWithFeatures
              data-testid="Pre-Invoice-adjustment"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={preInvoiceSummary?.map((item) => {
                return {
                  ...item,
                  adjustedUnit: item.adjustedUnit
                    ? item.adjustedUnit.toFixed(4)
                    : '0.0000',
                  // adjustmentRecordCount: item.adjustmentRecordCount
                  //   ? item.adjustmentRecordCount
                  //   : '0',
                  adjustmentRecordCount:Number( item.adjustmentRecordCount??0)
                   
                };
              })}
              columnDefs={PreInvoiceSummary}
              exportFile
              animateRows
              sideBar={false}
              fileName="PreInvoiceUnitAdj"
              reportName="Pre-Invoice Unit Adjustment Report"
              isScrollOn
              defaultColWidth={150}
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onFilterData={onFilterChanged}
              onCellFocused={onCellFocused}
              pinnedBottomRowData={pinnedBottomRowData}
              info={{ secondInfo, thirdInfo ,rowCount:summaryResultCount}}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              getFilterApply={getFilterApplySummary}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 20)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplayPreInvoice;
